import { render, staticRenderFns } from "./SubjectAreas.vue?vue&type=template&id=8d88dc38&lang=pug&"
import script from "./SubjectAreas.vue?vue&type=script&lang=js&"
export * from "./SubjectAreas.vue?vue&type=script&lang=js&"
import style0 from "./SubjectAreas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports